const MeetingNavbar = () => {
  return (
    <nav className="flex justify-between px-20 py-1.5 mx-6 bg-[#f8f9f9] h-[120px] rounded-b-xl border border-[#E9E9E9]">
      <img src="/logo.png" alt="logo" height={90} width={58} />
    </nav>
  );
};

export default MeetingNavbar;
